import { getAuth0 } from "@/auth";
import { URL } from "@/env";
import store from "@/store";
import authService from "./authService";
import chatService from "./chatService";
import idleService from "./idleService";
import localStorageService from "./localStorageService";
import notificationSessionService from "./notificationSessionService";
import sessionState from "./sessionState";

export default {
  /**
   * The single logout path. `remote` is set when another tab already signed out, so the signal and the
   * revocation that tab already did are not repeated.
   */
  async signOut({ returnTo = URL, remote = false } = {}) {
    if (sessionState.isSigningOut()) return;
    sessionState.beginSigningOut();

    // Claimed before anything is awaited, so a sibling tab reaching its own deadline meanwhile follows this
    // sign-out instead of revoking the user's refresh tokens a second time.
    if (!remote) idleService.signalSignedOut();

    idleService.stop();
    notificationSessionService.disconnect();
    await chatService.disconnect();

    const auth0 = getAuth0();
    // The tab that signed out already revoked the refresh tokens; repeating it could kill a session re-created there.
    if (!remote) {
      try {
        await auth0?.getAccessTokenSilently();
      } catch {
        // Revocation is best effort; the Auth0 logout below must still run.
      }
      await authService.logout();
      // Written again, because localStorageService.clear() calls localStorage.clear() and wipes the claim above.
      localStorageService.clear();
      idleService.signalSignedOut();
    }

    store.dispatch("auth0Store/clearSelectedCompanyId");
    await auth0?.logout({ logoutParams: { returnTo } });
  },
};
